import { render } from "./WQedit.vue?vue&type=template&id=385c63f0&scoped=true"
import script from "./WQedit.vue?vue&type=script&lang=js"
export * from "./WQedit.vue?vue&type=script&lang=js"

import "./WQedit.vue?vue&type=style&index=0&id=385c63f0&lang=scss&scoped=true"
import "./WQedit.vue?vue&type=style&index=1&id=385c63f0&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385c63f0"]])

export default __exports__